import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ComplianceBootstrapDto, UserKycApplicationListItemDto } from '../../../_core/_model/compliance';
import { ComplianceApiService } from '../../../_core/_services/_compliance/compliance-api.service';
import { NotificationService } from '../../../_core/_services/notification.service';

@Component({
  selector: 'app-compliance-dashboard',
  standalone: false,
  templateUrl: './compliance-dashboard.html',
  styleUrl: './compliance-dashboard.css',
})
export class ComplianceDashboard implements OnInit {
  loading = false;
  starting = false;
  error: string | null = null;

  bootstrap: ComplianceBootstrapDto | null = null;
  latestApplication: UserKycApplicationListItemDto | null = null;

  constructor(
    private notifyService: NotificationService,
    private api: ComplianceApiService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.load();
  }

  load(): void {
    this.loading = true;
    this.error = null;

    this.api.getBootstrap().subscribe({
      next: (res) => {
        this.bootstrap = res.data || null;
        this.latestApplication = this.bootstrap?.latestApplication || null;
        this.loading = false;
      },
      error: (err) => {
        this.error = err?.error?.message || 'Failed to load compliance dashboard.';
        this.notifyService.showError(this.error!, 'Error');
        this.loading = false;
      }
    });
  }

  startApplication(): void {
    this.starting = true;
    this.error = null;

    this.api.startApplication().subscribe({
      next: (res) => {
        const app = res.data;
        this.starting = false;
        this.router.navigate(['/compliance/wizard', app.applicationId]);
      },
      error: (err) => {
        this.error = err?.error?.message || 'Failed to start application.';
        this.starting = false;
      }
    });
  }

  continueApplication(): void {
    if (!this.latestApplication?.applicationId) return;
    this.router.navigate(['/compliance/wizard', this.latestApplication.applicationId]);
  }

  openLatest(): void {
    if (!this.latestApplication?.applicationId) return;
    this.router.navigate(['/compliance/application', this.latestApplication.applicationId]);
  }

  openApplications(): void {
    this.router.navigate(['/compliance/applications']);
  }

  openTierTable(): void {
    this.router.navigate(['/compliance/tier-table']);
  }

  getStatusClass(status?: string): string {
    switch (status) {
      case 'Approved': return 'text-bg-success';
      case 'Rejected': return 'text-bg-danger';
      case 'Submitted':
      case 'UnderReview': return 'text-bg-warning';
      default: return 'text-bg-secondary';
    }
  }

  canContinue(): boolean {
    const status = this.latestApplication?.status;
    return status === 'Draft' || status === 'PendingSubmission' || status === 'Rejected';
  }

  canStartNew(): boolean {
    return !this.latestApplication || this.latestApplication.status === 'Approved';
  }
}